import dayjs from 'dayjs';

export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY';

export const dateValidation=(date: string):string=>{
    if(date==null)
    {
        return "";
    }
    return new Date(date).getFullYear() > 1900 ? dayjs(date).format(DISPLAY_DATE_FORMAT) : ""
} 